/**
 * Returns if two positions are contiguous. Used when opening a new experience
 * from the box view to check if current open one is contiguous to the new one
 * or not. 3/2 is used as the second operand because desktop view has 3
 * experiences per row and tablet/small screens 2 experiences per row
 * @param { number } posSelected The current position of the experience selected
 * @param { number } newPos The new position of the experience to show its preview
 */
export default function areContiguous(posSelected, newPos) {
  if (window.innerWidth < 1160) {
    if (posSelected % 2 === 0) {
      return newPos === posSelected + 1;
    }
    return newPos === posSelected - 1;
  }
  if (posSelected % 3 === 0) {
    // first position selected
    return newPos === posSelected + 1 || newPos === posSelected + 2;
  } else if (posSelected % 3 === 1) {
    // second position selected
    return newPos === posSelected - 1 || newPos === posSelected + 1;
  }
  // third position selected
  return newPos === posSelected - 1 || newPos === posSelected - 2;
}
